import { api } from "./api";

const TOKEN_KEY = "tassei_admin_token";

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}
export function setToken(t) {
  localStorage.setItem(TOKEN_KEY, t);
}
export function clearToken() {
  localStorage.removeItem(TOKEN_KEY);
}
export function isAuthed() {
  return !!getToken();
}

function authHeaders() {
  const t = getToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
}

export async function adminLogin(username, password) {
  const { data } = await api.post("/admin/login", { username, password });
  setToken(data.token);
  return data;
}

export async function adminMe() {
  const { data } = await api.get("/admin/me", { headers: authHeaders() });
  return data;
}

export async function adminSubmissions() {
  const { data } = await api.get("/admin/submissions", { headers: authHeaders() });
  return data;
}

export function adminLogout() {
  clearToken();
}
